import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabCommunicationService {
  private activeTabIndexSource = new BehaviorSubject<number>(0);
  activeTabIndex$ = this.activeTabIndexSource.asObservable();

  //metal completion tab
  private metalCompletedSource = new BehaviorSubject<boolean>(false);
  metalCompleted$ = this.metalCompletedSource.asObservable();

  private stoneCompletedSource = new BehaviorSubject<boolean>(false);
  stoneCompleted$ = this.stoneCompletedSource.asObservable();

  private packagingCompletedSource = new BehaviorSubject<boolean>(false);
  packagingCompleted$ = this.packagingCompletedSource.asObservable();

  setActiveTab(index: number) {
    this.activeTabIndexSource.next(index);
  }
 
  setMetalCompleted(status: boolean) {
    this.metalCompletedSource.next(status);//metal completion state
  }

  setStoneCompleted(status: boolean) {
    this.stoneCompletedSource.next(status);
  }
  setPackagingCompleted(status: boolean) {
    this.packagingCompletedSource.next(status);
  }
}
